import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 导入语言文件
const messages = {
  'en': require('./locales/en.json'),
  'zh-TW': require('./locales/zh-TW.json')
}

// 从 localStorage 获取保存的语言,如果没有则默认使用英文
const savedLocale = localStorage.getItem('locale') || 'en'
console.log('1111', savedLocale)
const i18n = new VueI18n({
  locale: savedLocale, // 设置当前语言
  fallbackLocale: 'en', // 设置回退语言
  messages // 语言包
})

export default i18n
